<div id="pricing" class="pricing">
  <h2 class="pricing__title">{{ 'pricing.title' | transloco }}</h2>

  <div class="pricing-list">
    @for (plan of pricingPlans; track plan) {
      <div class="pricing-list__plan" [ngClass]="{'pricing-list__plan--selected': plan.mostPopular}">
        <div>
          <div class="pricing-list__plan-header">
            <h3 class="pricing-list__plan-header-name">{{ plan.name | transloco }}</h3>
            <div class="price">
              <p class="price__value">{{ plan.price }}</p>
              <p class="price__label">{{ plan.frequency }}</p>
            </div>
            @if (plan.mostPopular) {
              <div class="pricing-list__plan-header-most-popular">
                <i class="fa-solid fa-star"></i>
                <p>{{ 'pricing.most_popular' | transloco }}</p>
              </div>
            }
            <p class="pricing-list__plan-header-description">{{ plan.description | transloco }}</p>
          </div>
          <div class="pricing-list__plan-advantages"
            [class.expanded]="plan.expanded"
            >
            @for (advantage of plan.advantages; track advantage) {
              <div class="pricing-list__plan-advantage">
                <div class="pricing-list__plan-advantage-icon">
                  <i class="fa-solid" [ngClass]="advantage.icon"></i>
                </div>
                <p class="pricing-list__plan-advantage-label">{{ advantage.key | transloco }}</p>
              </div>
            }
          </div>
          <button class="button button--small button--secondary button--see-all"
            (click)="toggleExpand(plan)">
            {{ plan.expanded ? ('pricing.hide-all-features' | transloco) : ('pricing.see-all-features' | transloco: {'number': plan.advantages.length}) }}
            <i class="fa-solid" [ngClass]="plan.expanded ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
          </button>
        </div>
        <a class="button button--large button--full-width"
          [routerLink]="'/register'"
          (click)="clickPlan(plan.trackingName)"
          >
          {{ 'pricing.try_now' | transloco }}
          <i class="fa-solid fa-arrow-right"></i>
        </a>
      </div>
    }
  </div>
</div>
